import { Button, Fade, Grid, Tooltip, Typography } from "@mui/material";

import { useKeikkaData } from "src/context/KeikkaDataContext";

import IconsContainer from "src/components/icons/others/IconsContainer";
import PropTypes from "prop-types";
import MySkeleton from "src/components/layout/MySkeleton";

export default function PumppausRow(props) {
  const { keikkaData } = useKeikkaData();
  const fadeTime = 500;

  const handleRowClick = () => props.onClick();
  const isError =
    keikkaData.auth.edit &&
    keikkaData.tila.keikkaTilaId < 5 &&
    keikkaData.pumppu.pumppuError() != null;

  const styles = {
    div: {
      padding: isError ? "10px" : "0px",
      transition: "all 0.6s ease-in-out",
    },
  };
  return (
    <div style={styles.div}>
      <Tooltip
        disableInteractive
        title={isError && keikkaData.pumppu.pumppuError(keikkaData.tila.keikkaTilaId < 4)}
        placement="top-end"
        arrow>
        <Button
          variant={keikkaData.auth.edit && keikkaData.pumppu.pumppuError() ? "outlined" : "text"}
          sx={{ minHeight: "50px", margin: 0, padding: 0, transition: "all 0.9s ease-in-out" }}
          onClick={handleRowClick}
          fullWidth
          aria-label="Muokkaa pumppausta">
          <Grid container className="stepRow" sx={{ width: "100%" }}>
            <Grid size={{ xs: 3 }} sx={{ textAlign: "right" }}>
              <Typography
                variant="h6"
                sx={{ paddingRight: "5px" }}
                noWrap
                color="primary"
                className="fixPrint transitionElement">
                Pumppu:
              </Typography>
            </Grid>

            {keikkaData.keikkaId === 0 || keikkaData.isLoading ? (
              <MySkeleton width="70%" height="35px" />
            ) : (
              <>
                <Fade in={true} timeout={fadeTime}>
                  <Grid
                    size={{ xs: 8 }}
                    sx={{
                      paddingTop: "5px",
                      textAlign: "left",
                    }}>
                    {keikkaData.auth.read && (
                      <div>
                        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                          <Typography
                            variant="body"
                            color="primary"
                            className="fixPrint transitionElement">
                            {keikkaData.pumppuToimittaja.asiakasNimi}{" "}
                          </Typography>
                          {keikkaData.pumppuToimittaja.sijaintiMatkaM > 0 && (
                            <Typography
                              variant="body2"
                              color="primary"
                              className="fixPrint transitionElement">
                              {Math.round(keikkaData.pumppuToimittaja.sijaintiMatkaM / 1000)} km
                            </Typography>
                          )}
                        </div>
                        <Typography
                          color={
                            keikkaData.pumppu.pumppuStringLong != null ? "primary" : "warning.main"
                          }
                          className="fixPrint transitionElement">
                          {keikkaData.pumppu.pumppuStringLong != null
                            ? keikkaData.pumppu.pumppuStringLong
                            : keikkaData.auth.edit
                            ? "Valitse pumppu"
                            : "Pumppu puuttuu"}
                        </Typography>
                        {keikkaData.pumppu.pumppuLinja != null && (
                          <Typography color="primary" className="fixPrint transitionElement" noWrap>
                            {keikkaData.pumppu.linjaStringLong}
                          </Typography>
                        )}
                      </div>
                    )}
                  </Grid>
                </Fade>
                <Fade in={true} timeout={fadeTime}>
                  <Grid size={{ xs: 1 }} className="frontPageEditIcon">
                    <IconsContainer
                      showWarning={
                        keikkaData.tila.keikkaTilaId < 5 && keikkaData.pumppu.pumppuError() != null
                      }
                      showEdit={keikkaData.auth.edit}
                      editOpacity={0.5}
                    />
                  </Grid>
                </Fade>
              </>
            )}
          </Grid>
        </Button>
      </Tooltip>
    </div>
  );
}

PumppausRow.propTypes = {
  onClick: PropTypes.func,
};
